import {
  colors as colorsFromNospenPackages,
  hexToRgbA as hexToRgbAFromNospenPackages,
  mixColors as mixColorsFromNospenPackages,
} from '@domagude/nospen-packages/frontend/ui/theme';

const themeMode = localStorage.getItem('themeMode');

export const colors =
  themeMode === 'light' ? colorsFromNospenPackages : colorsFromNospenPackages;

export const hexToRgbA = hexToRgbAFromNospenPackages;

export const mixColors = mixColorsFromNospenPackages;
